import React, { useEffect, useState } from "react";
import {
  Form,
  Button,
  Input,
  Card,
  message,
  Transfer,
  Switch,
  Row,
  Col,
  Icon,
  Divider,
  Spin,
  Tag
} from "antd";
import api from "../../../services/api";

const panelStyle = {
  borderRadius: 12,
  boxShadow: "0 12px 32px rgba(0,0,0,0.08)",
  border: "1px solid #f0f0f0",
  fontSize: 14
};
const inputStyle = { fontSize: 14 };

const Cadastro = props => {
  const { form, history, location } = props;
  const { getFieldDecorator } = form;

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [permissionsData, setPermissionsData] = useState([]);
  const [targetPermissions, setTargetPermissions] = useState([]);
  const [user, setUser] = useState(null);

  useEffect(() => {
    var record = null;
    if (location && location.state && location.state.record) {
      record = location.state.record;
    }
    // If "record" is an empty object (from "Novo" button), user stays null
    if (record && record.id) {
      setUser(record);
    }
    fetchData(record && record.id ? record : null);
  }, []);

  const fetchData = async currentUser => {
    setLoading(true);
    try {
      // Fetch permissions from our newly created endpoint
      const permRes = await api.get("/pasta/permissions/");

      const permList = [];
      const permTargets = [];
      if (permRes && permRes.data) {
        permRes.data.forEach(function mapPerm(value) {
          permList.push({
            key: value.id.toString(),
            title: value.name,
            description: value.codename
          });
          // Check if current user has this permission
          // Note: The UserListSerializer does NOT return full permissions list for the user object in the list view.
          // We might need to fetch the single user details to get permissions, or trust what was passed.
          // However, standard django user serializer doesn't usually nest full permissions objects unless configured.
          // For now, let's assume we might not have permissions populated in `currentUser` unless we fetch detail.
          // But `currentUser` passed here comes from the List view state.
          // Let's verify if we need to fetch user detail.
        });
      }

      if (currentUser && currentUser.id) {
          // Ideally fetch fresh user data to get permissions
          // But since we didn't update the UserViewSet to return permissions in detail view explicitly yet (only Basic fields),
          // We might miss them.
          // Standard Django User model has `user_permissions`.
          // Let's try to fetch user detail from /pasta/users/{id}/
          try {
             const userDetail = await api.get(`/pasta/users/${currentUser.id}/`);
             if (userDetail.data) {
                 // Atualiza currentUser com os dados detalhados vindos da API
                 currentUser = userDetail.data;
                 
                 if (userDetail.data.user_permissions) {
                     userDetail.data.user_permissions.forEach(pId => {
                         permTargets.push(pId.toString());
                     })
                 }
             }
          } catch(e) {
              console.error("Error fetching user detail", e);
          }
      }

      setPermissionsData(permList);
      setTargetPermissions(permTargets);

      form.setFieldsValue({
        nome: currentUser ? (currentUser.nome || currentUser.first_name) : "",
        username: currentUser ? currentUser.username : "",
        email: currentUser ? currentUser.email : "",
        is_active: currentUser ? currentUser.is_active : true,
        is_superuser: currentUser ? currentUser.is_superuser : false,
      });
    } catch (err) {
      console.error(err);
      message.error("Erro ao carregar dados do formulário.");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = e => {
    e.preventDefault();
    form.validateFields(async (err, values) => {
      if (err) return;

      setSaving(true);
      try {
        var payload = {
          first_name: values.nome, // Map back to django field
          username: values.username,
          email: values.email,
          is_active: values.is_active,
          is_superuser: values.is_superuser,
          user_permissions: targetPermissions.map(function toInt(key) {
            return parseInt(key, 10);
          })
        };

        if (values.password) {
          payload.password = values.password;
        }

        if (user && user.id) {
          await api.patch(`/pasta/users/${user.id}/`, payload);
          message.success("Usuário atualizado com sucesso.");
        } else {
          await api.post("/pasta/users/", payload);
          message.success("Usuário cadastrado com sucesso.");
        }

        history.push({ pathname: "/user_list" });
      } catch (error) {
        console.error(error);
        var errorMsg = "Ocorreu um erro ao salvar.";
        if (error.response && error.response.data) {
            // Django REST usually returns object with field errors
            errorMsg = JSON.stringify(error.response.data);
        }
        message.error(errorMsg);
      } finally {
        setSaving(false);
      }
    });
  };

  const title =
    user && user.username ? "Editar usuário: " + user.username : "Cadastrar novo usuário";

  if (loading) {
    return (
      <div style={{ padding: 24, textAlign: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ padding: 24 }}>
      <Card
        title={
          <span style={{ display: "flex", alignItems: "center" }}>
            <Icon type="user" style={{ marginRight: 8 }} />
            {title}
          </span>
        }
        extra={
          user ? (
            <Tag color={user.is_active ? "green" : "red"}>
              {user.is_active ? "Ativo" : "Inativo"}
            </Tag>
          ) : (
            <Tag color="blue">Novo</Tag>
          )
        }
        style={panelStyle}
        headStyle={{ fontSize: 16, fontWeight: 700 }}
      >
        <Form layout="vertical" onSubmit={handleSubmit}>
          <Row gutter={16}>
            <Col md={12} sm={24} xs={24}>
              <Form.Item 
                label="Nome"
                help={user && !(user.nome || user.first_name) ? "Usuário sem nome cadastrado, por favor adicione." : null}
                validateStatus={user && !(user.nome || user.first_name) ? "warning" : null}
              >
                {getFieldDecorator("nome", {
                  initialValue: user ? (user.nome || user.first_name || user.username) : "",
                  rules: [{ required: true, message: "Informe o nome completo." }]
                })(<Input placeholder="Nome completo" style={inputStyle} />)}
              </Form.Item>

              <Form.Item label="Login">
                {getFieldDecorator("username", {
                  initialValue: user ? user.username : "",
                  rules: [{ required: true, message: "Informe o login." }]
                })(<Input placeholder="Nome de usuário" style={inputStyle} />)}
              </Form.Item>

              <Form.Item label={user ? "Nova Senha (deixe em branco para manter)" : "Senha inicial"}>
                {getFieldDecorator("password", {
                  rules: [{ required: !user, message: "Defina uma senha." }]
                })(<Input.Password placeholder="Senha" style={inputStyle} />)}
              </Form.Item>

              <Form.Item label="Email">
                {getFieldDecorator("email", {
                  initialValue: user ? user.email : "",
                  rules: [
                    { required: false, message: "Informe o email." },
                    { type: "email", message: "Email inválido." }
                  ]
                })(<Input placeholder="email@dominio.com" style={inputStyle} />)}
              </Form.Item>
            </Col>

            <Col md={12} sm={24} xs={24}>
              <Row gutter={12}>
                <Col xs={12} sm={12}>
                  <Form.Item label="Ativo" style={{ marginBottom: 0 }}>
                    {getFieldDecorator("is_active", {
                      initialValue: user ? user.is_active : true,
                      valuePropName: "checked"
                    })(<Switch checkedChildren="Sim" unCheckedChildren="Não" />)}
                  </Form.Item>
                </Col>
                <Col xs={12} sm={12}>
                  <Form.Item label="Administrador" style={{ marginBottom: 0 }}>
                    {getFieldDecorator("is_superuser", {
                      initialValue: user ? user.is_superuser : false,
                      valuePropName: "checked"
                    })(<Switch checkedChildren="Sim" unCheckedChildren="Não" />)}
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>

          <Divider />

          <Card
            type="inner"
            title="Permissões"
            style={{ marginBottom: 16, borderRadius: 10, boxShadow: "0 8px 20px rgba(0,0,0,0.06)" }}
            bodyStyle={{ overflowX: "auto" }}
          >
            <Transfer
              dataSource={permissionsData}
              showSearch
              listStyle={{ width: "45%", height: 300 }}
              targetKeys={targetPermissions}
              onChange={function onChange(keys) {
                setTargetPermissions(keys);
              }}
              render={function renderItem(item) {
                return item.title;
              }}
              titles={["Disponíveis", "Atribuídas"]}
              locale={{
                itemUnit: "item",
                itemsUnit: "itens",
                searchPlaceholder: "Buscar permissão"
              }}
            />
          </Card>

          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 24, gap: 8, flexWrap: "wrap" }}>
            <Button style={{ marginRight: 8 }} onClick={function onCancel() { history.push("/user_list"); }} size="large">
              Cancelar
            </Button>
            <Button type="primary" htmlType="submit" loading={saving} icon="save" size="large">
              Salvar usuário
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export const CadastroForm = Form.create({ name: "cadastro_form" })(Cadastro);



// WEBPACK FOOTER //
// ./src/pages/Usuario/Listagem/form.js